import Link from "next/link"

const CategoryTile = ({ category }) => {
  return (
    <Link href={`/venues?type=${category.type}`}>
      <div className="p-1 pl-3 bg-white shadow-md border border-gray-300 rounded-lg cursor-pointer flex flex-row items-center hover:bg-gray-500">
        <div className="flex-1 py-2">{category.name}</div>
        <div className="p-2 text-2xl font-bold">{category.count}</div>
      </div>
    </Link>
  )
}
const OptionsWrapper = ({ children }) => (
  <div className="flex flex-row overflow-x-auto py-1">{children} </div>
)

const OptionTile = ({ label, href }) => (
  <Link href={href}>
    <a href={href}>
      <div className="inline-block px-2 py-1 bg-gray-100 rounded-xl mr-2 text-sm hover:bg-gray-200 transition-colors whitespace-nowrap">
        {label}
      </div>
    </a>
  </Link>
)

// sportowe/sale-zabaw/warszawa
const CategoryOptions = ({ values, city }) => (
  <OptionsWrapper>
    {values
      .sort((a, b) => b.count - a.count)
      .map((val: any) => {
        const link = `/${val.parentCode}/${val.code}/${city.code}`
        return <OptionTile label={val.name} href={link} />
      })}
  </OptionsWrapper>
)

const LocationOptions = ({ values, category }) => (
  <OptionsWrapper>
    {values
      .sort((a, b) => b.count - a.count)
      .map((val: any) => {
        const link = `/${category.parentCode}/${category.code}/${val.code}`
        return <OptionTile label={val.name} href={link} />
      })}
  </OptionsWrapper>
)

export const StatsLinks = ({ stats, city, category }) => {
  // This is city page and there are categories
  if (city && stats?.categories && stats?.categories.length > 0) {
    return <CategoryOptions values={stats.categories} city={city} />
  }
  if (category && stats?.locations && stats?.locations.length > 0) {
    return <LocationOptions values={stats.locations} category={category} />
  }
  // if (stats.categories) {
  //   return (
  //     <div className="w-full">
  //       <div className="grid grid-cols-4 gap-4 w-full ">
  //         {stats.categories
  //           .filter((cat: any) => !!cat.code)
  //           .map((cat: any) => {
  //             return <CategoryTile category={cat} />
  //           })}
  //       </div>
  //     </div>
  //   )
  // }
  return <div />
}
